export class FileImport{
    idLoaiHH: number;
    base64: string;
    fileByte: any;
    filename: string;
    dienGiai: string;
    extension: string;
	IdLoai: number

    clear(){
        this.idLoaiHH = 0;
        this.base64= '';
        this.fileByte= null;
        this.filename= '';
        this.dienGiai= '';
        this.extension= '';
		this.IdLoai = 0;
    }

    copy(item: FileImport){
        this.idLoaiHH = item.idLoaiHH;
        this.base64= item.base64;
        this.fileByte= item.fileByte;
        this.filename= item.filename;
        this.dienGiai= item.dienGiai;
        this.extension= item.extension;
		this.IdLoai = item.IdLoai;
    }
}
